module.exports = __webpack_public_path__ + "static/media/10.bb4cfc05.jpg";